export default __webpack_public_path__ + "254c5ae13dd5180b0bd6c718d7b5668e.png";